export enum PlatformType {
  cafe24 = 'cafe24',
  hmall = 'hmall',
  larosee = 'larosee',
  imweb = 'imweb'
}
